import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition
  } else {
    return {
      x: 0,
      y: 0
    }
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  linkActiveClass: 'active',
  routes: [
    // {
    //   path: '/',redirect: '/wx_notice'
    // },
    //微信开门
    {
      path: '/wx_testMenu',
      name: 'wx_testMenu',
      component: () => import('@/views/wx_testMenu/index'),

      hidden: true,
      meta: {
        title: '微信开门'
      }
    },
    //我的订单
    {
      path: '/wx_testOrder',
      name: 'wx_testOrder',
      component: () => import('@/views/wx_testOrder/index'),

      hidden: true,
      meta: {
        title: '我的订单'
      }
    },
    //我的积分
    {
      path: '/wx_testIntegral',
      name: 'wx_testIntegral',
      component: () => import('@/views/wx_testIntegral/index'),

      hidden: true,
      meta: {
        title: '我的积分'
      }
    },
    //垃圾分类
    {
      path: '/wx_testClassification',
      name: 'wx_testClassification',
      component: () => import('@/views/wx_testClassification/index'),

      hidden: true,
      meta: {
        title: '垃圾分类'
      }
    },
    //我的发票
    {
      path: '/wx_testInvoice',
      name: 'wx_testInvoice',
      component: () => import('@/views/wx_testInvoice/index'),

      hidden: true,
      meta: {
        title: '我的发票'
      }
    },
    //我的发票抬头
    {
      path: '/wx_testInvoiceTop',
      name: 'wx_testInvoiceTop',
      component: () => import('@/views/wx_testInvoiceTop/index'),

      hidden: true,
      meta: {
        title: '我的发票抬头'
      }
    },
    //我的钥匙
    {
      path: '/wx_testKey',
      name: 'wx_testKey',
      component: () => import('@/views/wx_testKey/index'),

      hidden: true,
      meta: {
        title: '我的钥匙'
      }
    },
    //我的地址
    {
      path: '/wx_testAddress',
      name: 'wx_testAddress',
      component: () => import('@/views/wx_testAddress/index'),

      hidden: true,
      meta: {
        title: '我的地址'
      }
    },
    //积分任务
    {
      path: '/wx_testTask',
      name: 'wx_testTask',
      component: () => import('@/views/wx_testTask/index'),

      hidden: true,
      meta: {
        title: '积分任务'
      }
    },
    //邀请任务
    {
      path: '/wx_testInvitation',
      name: 'wx_testInvitation',
      component: () => import('@/views/wx_testInvitation/index'),

      hidden: true,
      meta: {
        title: '邀请任务'
      }
    },
    {
      path: '/wx_index',
      name: 'wx_index',
      component: () => import('@/views/wx_index/index'),

      hidden: true,
      meta: {
        title: '首页'
      }
    },
    //商城页面
    {
      path: '/wx_myShop',
      name: 'wx_myShop',
      component: () => import('@/views/wx_myShop/index'),

      hidden: true,
      meta: {
        title: '商城'
      }
    },
    //生活页面
    {
      path: '/wx_myService',
      name: 'wx_myService',
      component: () => import('@/views/wx_myService/index'),

      hidden: true,
      meta: {
        title: '服务'
      }
    },
    {
      path: '/wx_login',
      name: 'wx_login',
      component: () => import('@/views/wx_login/index'),

      hidden: true,
      meta: {
        title: '登录页'
      }
    },
    {
      path: '/wx_notice',
      name: 'wx_notice',
      component: () => import('@/views/wx_notice/index'),

      hidden: true,
      meta: {
        title: '公告信息',
        keepAlive: false
      }
    },
    {
      path: '/wx_noticeDetail',
      name: 'wx_noticeDetail',
      component: () => import('@/views/wx_noticeDetail/index'),

      hidden: true,
      meta: {
        title: '公告详情'
      }
    },
    {
      path: '/wx_wenjuan',
      name: 'wx_wenjuan',
      component: () => import('@/views/wx_wenjuan/index'),

      hidden: true,
      meta: {
        title: '调查问卷'
      }
    },
    {
      path: '/wx_tipsMessage',
      name: 'wx_tipsMessage',
      component: () => import('@/views/wx_tipsMessage/index'),

      hidden: true,
      meta: {
        title: '提醒消息',
        keepAlive: false
      }
    },
    {
      path: '/wx_tipsMessageList',
      name: 'wx_tipsMessageList',
      component: () => import('@/views/wx_tipsMessageList/index'),

      hidden: true,
      meta: {
        title: '提醒消息',
        keepAlive: false
      }
    },
    {
      path: '/wx_tipsMessageDetail',
      name: 'wx_tipsMessageDetail',
      component: () => import('@/views/wx_tipsMessageDetail/index'),

      hidden: true,
      meta: {
        title: '消息详情'
      }
    },
    {
      path: '/wx_myNoticemngList',
      name: 'wx_myNoticemngList',
      component: () => import('@/views/wx_myNoticemngList/index'),

      hidden: true,
      meta: {
        title: '缴费通知单',
        keepAlive: false
      }
    },
    {
      path: '/wx_myNoticemngDetail',
      name: 'wx_myNoticemngDetail',
      component: () => import('@/views/wx_myNoticemngDetail/index'),

      hidden: true,
      meta: {
        title: '账单详情'
      }
    },
    {
      path: '/wx_myPayHistory',
      name: 'wx_myPayHistory',
      component: () => import('@/views/wx_myPayHistory/index'),

      hidden: true,
      meta: {
        title: '缴费历史',
        keepAlive: false
      }
    },
    {
      path: '/wx_myPayDetail',
      name: 'wx_myPayDetail',
      component: () => import('@/views/wx_myPayDetail/index'),

      hidden: true,
      meta: {
        title: '缴费详情'
      }
    },
    {
      path: '/wx_myPayMg',
      name: 'wx_myPayMg',
      component: () => import('@/views/wx_myPayMg/index'),

      hidden: true,
      meta: {
        title: '电子收据'
      }
    },
    {
      path: '/wx_myCardAndTicket',
      name: 'wx_myCardAndTicket',
      component: () => import('@/views/wx_myCardAndTicket/index'),

      hidden: true,
      meta: {
        title: '卡券'
      }
    },

    {
      path: '/wx_myInfo',
      name: 'wx_myInfo',
      component: () => import('@/views/wx_myInfo/index'),

      hidden: true,
      meta: {
        title: '我的',
        keepAlive: false
      }
    },

    {
      path: '/wx_comTelephone',
      name: 'wx_comTelephone',
      component: () => import('@/views/wx_comTelephone/index'),

      hidden: true,
      meta: {
        title: '呼叫中心'
      }
    },
    {
      path: '/wx_myInfoDetail',
      name: 'wx_myInfoDetail',
      component: () => import('@/views/wx_myInfoDetail/index'),

      hidden: true,
      meta: {
        title: '个人信息'
      }
    },
    {
      path: '/wx_myInfoBind',
      name: 'wx_myInfoBind',
      component: () => import('@/views/wx_myInfoBind/index'),

      hidden: true,
      meta: {
        title: '号码绑定'
      }
    },
    {
      path: '/wx_myHouse',
      name: 'wx_myHouse',
      component: () => import('@/views/wx_myHouse/index'),

      hidden: true,
      meta: {
        title: '我的物业'
      }
    },
    {
      path: '/wx_myHouseBind',
      name: 'wx_myHouseBind',
      component: () => import('@/views/wx_myHouseBind/index'),

      hidden: true,
      meta: {
        title: '绑定物业'
      }
    },
    {
      path: '/wx_myRepair',
      name: 'wx_myRepair',
      component: () => import('@/views/wx_myRepair/index'),

      hidden: true,
      meta: {
        title: '客户报修',
        keepAlive: false
      }
    },
    {
      path: '/wx_myRepairAdd',
      name: 'wx_myRepairAdd',
      component: () => import('@/views/wx_myRepairAdd/index'),

      hidden: true,
      meta: {
        title: '新增报修'
      }
    },
    {
      path: '/wx_myRepairDetail',
      name: 'wx_myRepairDetail',
      component: () => import('@/views/wx_myRepairDetail/index'),

      hidden: true,
      meta: {
        title: '报修详情'
      }
    },
    {
      path: '/wx_repairManage',
      name: 'wx_repairManage',
      component: () => import('@/views/wx_repairManage/index'),

      hidden: true,
      meta: {
        title: '报修管理',
        keepAlive: false
      }
    },
    {
      path: '/wx_myPassApplication',
      name: 'wx_myPassApplication',
      component: () => import('@/views/wx_myPassApplication/index'),

      hidden: true,
      meta: {
        title: '放行申请',
        keepAlive: false
      }
    },
    {
      path: '/wx_myPassApplicationAdd',
      name: 'wx_myPassApplicationAdd',
      component: () => import('@/views/wx_myPassApplicationAdd/index'),

      hidden: true,
      meta: {
        title: '新增申请'
      }
    },
    {
      path: '/wx_myPassApplicationDetail',
      name: 'wx_myPassApplicationDetail',
      component: () => import('@/views/wx_myPassApplicationDetail/index'),

      hidden: true,
      meta: {
        title: '申请详情'
      }
    },
    {
      path: '/wx_repairForMyself',
      name: 'wx_repairForMyself',
      component: () => import('@/views/wx_repairForMyself/index'),

      hidden: true,
      meta: {
        title: '我的工单',
        keepAlive: false
      }
    },
    {
      path: '/wx_myRecement',
      name: 'wx_myRecement',
      component: () => import('@/views/wx_myRecement/index'),

      hidden: true,
      meta: {
        title: '缴费服务',
        keepAlive: false
      }
    },
    {
      path: '/wx_myRecement_byphone',
      name: 'wx_myRecement_byphone',
      component: () => import('@/views/wx_myRecement/getByphone'),
      hidden: true,
      meta: {
        title: '扫码缴费',
        keepAlive: false
      }
    },
    {
      path: '/wx_repairHuidan',
      name: 'wx_repairHuidan',
      component: () => import('@/views/wx_repairHuidan/index'),

      hidden: true,
      meta: {
        title: '维修回单'
      }
    },
    {
      path: '/wx_repairPaidan',
      name: 'wx_repairPaidan',
      component: () => import('@/views/wx_repairPaidan/index'),

      hidden: true,
      meta: {
        title: '维修派单'
      }
    },
    {
      path: '/wx_repairBanjie',
      name: 'wx_repairBanjie',
      component: () => import('@/views/wx_repairBanjie/index'),

      hidden: true,
      meta: {
        title: '办结'
      }
    },
    {
      path: '/wx_repairCuiban',
      name: 'wx_repairCuiban',
      component: () => import('@/views/wx_repairCuiban/index'),

      hidden: true,
      meta: {
        title: '催办'
      }
    },
    {
      path: '/wx_repairYanshou',
      name: 'wx_repairYanshou',
      component: () => import('@/views/wx_repairYanshou/index'),

      hidden: true,
      meta: {
        title: '验收'
      }
    },
    {
      path: '/wx_repairHuifang',
      name: 'wx_repairHuifang',
      component: () => import('@/views/wx_repairHuifang/index'),

      hidden: true,
      meta: {
        title: '回访'
      }
    },
    {
      path: '/wx_patrol',
      name: 'wx_patrol',
      component: () => import('@/views/wx_patrol/index'),

      hidden: true,
      meta: {
        title: '安全巡查',
        keepAlive: false
      }
    },
    {
      path: '/wx_patrol_task',
      name: 'wx_patrol_task',
      component: () => import('@/views/wx_patrol_task/index'),

      hidden: true,
      meta: {
        title: '巡查路线',
        keepAlive: false
      }
    },
    {
      path: '/wx_patrol_task_resuilt',
      name: 'wx_patrol_task_resuilt',
      component: () => import('@/views/wx_patrol_task_resuilt/index'),

      hidden: true,
      meta: {
        title: '巡查结果',
        keepAlive: false
      }
    },
    {
      path: '/wx_attendance',
      name: 'wx_attendance',
      component: () => import('@/views/wx_attendance/index'),

      hidden: true,
      meta: {
        title: '考勤签到'
      }
    },
    {
      path: '/wx_customerManage',
      name: 'wx_customerManage',
      component: () => import('@/views/wx_customerManage/index'),

      hidden: true,
      meta: {
        title: '客户管理',
        keepAlive: false
      }
    },
    {
      path: '/wx_customerOwe',
      name: 'wx_customerOwe',
      component: () => import('@/views/wx_customerOwe/index'),

      hidden: true,
      meta: {
        title: '客户欠费',
        keepAlive: false
      }
    },
    {
      path: '/wx_customerOfMyself',
      name: 'wx_customerOfMyself',
      component: () => import('@/views/wx_customerOfMyself/index'),

      hidden: true,
      meta: {
        title: '客户管理',
        keepAlive: false
      }
    },
    {
      path: '/wx_customerAdd',
      name: 'wx_customerAdd',
      component: () => import('@/views/wx_customerAdd/index'),

      hidden: true,
      meta: {
        title: '客户新增'
      }
    },
    {
      path: '/wx_customerDetail',
      name: 'wx_customerDetail',
      component: () => import('@/views/wx_customerDetail/index'),

      hidden: true,
      meta: {
        title: '客户详情'
      }
    },
    {
      path: '/wx_customerEdit',
      name: 'wx_customerEdit',
      component: () => import('@/views/wx_customerEdit/index'),

      hidden: true,
      meta: {
        title: '客户编辑'
      }
    },
    {
      path: '/wx_customerAssign',
      name: 'wx_customerAssign',
      component: () => import('@/views/wx_customerAssign/index'),

      hidden: true,
      meta: {
        title: '客户指派'
      }
    },
    {
      path: '/wx_customerFollow',
      name: 'wx_customerFollow',
      component: () => import('@/views/wx_customerFollow/index'),

      hidden: true,
      meta: {
        title: '客户跟进'
      }
    },
    {
      path: '/wx_rentCenter',
      name: 'wx_rentCenter',
      component: () => import('@/views/wx_rentCenter/index'),

      hidden: true,
      meta: {
        title: '租控中心',
        keepAlive: true
      }
    },
    {
      path: '/wx_rentMessage',
      name: 'wx_rentMessage',
      component: () => import('@/views/wx_rentMessage/index'),

      hidden: true,
      meta: {
        title: '房源信息',
        keepAlive: false
      }
    },
    {
      path: '/wx_rentDetails',
      name: 'wx_rentDetails',
      component: () => import('@/views/wx_rentDetails/index'),

      hidden: true,
      meta: {
        title: '房源详情',
        keepAlive: false
      }
    },
    {
      path: '/wx_appointmentShowing',
      name: 'wx_appointmentShowing',
      component: () => import('@/views/wx_appointmentShowing/index'),

      hidden: true,
      meta: {
        title: '预约看房'
      }
    },
    {
      path: '/wx_dataCenter',
      name: 'wx_dataCenter',
      component: () => import('@/views/wx_dataCenter/index'),

      hidden: true,
      meta: {
        title: '数据中心'
      }
    },
    {
      path: '/wx_invRequirerList',
      name: 'wx_invRequirerList',
      component: () => import('@/views/wx_invRequirerList/index'),

      hidden: true,
      meta: {
        title: '发票购方列表'
      }
    },
    {
      path: '/wx_invRequirerAdd',
      name: 'wx_invRequirerAdd',
      component: () => import('@/views/wx_invRequirerAdd/index'),

      hidden: true,
      meta: {
        title: '新增发票购方'
      }
    },
    {
      path: '/wx_invRequirerDetail',
      name: 'wx_invRequirerDetail',
      component: () => import('@/views/wx_invRequirerDetail/index'),

      hidden: true,
      meta: {
        title: '发票购方信息'
      }
    },
    {
      path: '/wx_invRequirerEdit',
      name: 'wx_invRequirerEdit',
      component: () => import('@/views/wx_invRequirerEdit/index'),

      hidden: true,
      meta: {
        title: '编辑发票购方'
      }
    },
    {
      path: '/wx_reportHouse',
      name: 'wx_reportHouse',
      component: () => import('@/views/wx_reportHouse/index'),

      hidden: true,
      meta: {
        title: '房产资源统计',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportCustomer',
      name: 'wx_reportCustomer',
      component: () => import('@/views/wx_reportCustomer/index'),

      hidden: true,
      meta: {
        title: '客户分析',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportService',
      name: 'wx_reportService',
      component: () => import('@/views/wx_reportService/index'),

      hidden: true,
      meta: {
        title: '客服汇总',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportRecemng',
      name: 'wx_reportRecemng',
      component: () => import('@/views/wx_reportRecemng/index'),

      hidden: true,
      meta: {
        title: '应收汇总',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportUnreceived',
      name: 'wx_reportUnreceived',
      component: () => import('@/views/wx_reportUnreceived/index'),

      hidden: true,
      meta: {
        title: '未收统计',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportReceived',
      name: 'wx_reportReceived',
      component: () => import('@/views/wx_reportReceived/index'),

      hidden: true,
      meta: {
        title: '实收统计',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportPayment',
      name: 'wx_reportPayment',
      component: () => import('@/views/wx_reportPayment/index'),

      hidden: true,
      meta: {
        title: '应付汇总',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportUnpay',
      name: 'wx_reportUnpay',
      component: () => import('@/views/wx_reportUnpay/index'),

      hidden: true,
      meta: {
        title: '未付统计',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportPaid',
      name: 'wx_reportPaid',
      component: () => import('@/views/wx_reportPaid/index'),

      hidden: true,
      meta: {
        title: '已付统计',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportDeposit',
      name: 'wx_reportDeposit',
      component: () => import('@/views/wx_reportDeposit/index'),

      hidden: true,
      meta: {
        title: '押金汇总',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportConsume',
      name: 'wx_reportConsume',
      component: () => import('@/views/wx_reportConsume/index'),

      hidden: true,
      meta: {
        title: '单元能耗',
        keepAlive: false
      }
    },
    {
      path: '/wx_reportCommonConsume',
      name: 'wx_reportCommonConsume',
      component: () => import('@/views/wx_reportCommonConsume/index'),

      hidden: true,
      meta: {
        title: '公摊能耗',
        keepAlive: false
      }
    },
    {
      path: '/wx_meterRead',
      name: 'wx_meterRead',
      component: () => import('@/views/wx_meterRead/index'),

      hidden: true,
      meta: {
        title: '能耗管理',
        keepAlive: false
      }
    },
    {
      path: '/wx_meterReadUnit',
      name: 'wx_meterReadUnit',
      component: () => import('@/views/wx_meterReadUnit/index'),

      hidden: true,
      meta: {
        title: '单元抄表',
        keepAlive: false
      }
    },
    {
      path: '/wx_meterReadPublic',
      name: 'wx_meterReadPublic',
      component: () => import('@/views/wx_meterReadPublic/index'),

      hidden: true,
      meta: {
        title: '公用抄表',
        keepAlive: false
      }
    },
    {
      path: '/wx_meterReadParent',
      name: 'wx_meterReadParent',
      component: () => import('@/views/wx_meterReadParent/index'),

      hidden: true,
      meta: {
        title: '总表抄表',
        keepAlive: false
      }
    },
    {
      path: '/wx_saomaPay',
      name: 'wx_saomaPay',
      component: () => import('@/views/wx_saomaPay/index'),

      hidden: true,
      meta: {
        title: '扫码支付',
        keepAlive: false
      }
    },
    {
      path: '/wx_parkingPay',
      name: 'wx_parkingPay',
      component: () => import('@/views/wx_parkingPay/index'),

      hidden: true,
      meta: {
        title: '停车缴费',
        keepAlive: false
      }
    },
    {
      path: '/wx_noneCarIn',
      name: 'wx_noneCarIn',
      component: () => import('@/views/wx_parkingPay/NoneCarIn'),

      hidden: true,
      meta: {
        title: '车辆入场',
        keepAlive: false
      }
    },
    {
      path: '/wx_noneCarOut',
      name: 'wx_noneCarOut',
      component: () => import('@/views/wx_parkingPay/NoneCarOut'),

      hidden: true,
      meta: {
        title: '车辆出场',
        keepAlive: false
      }
    },
    // {
    //   path: '/if',
    //   name: 'if',
    //   component: () => import('@/views/if/index'),
    //   hidden: true,
    //   meta: {
    //     title: '停车缴费',
    //     keepAlive: false
    //   },

    // },

    {
      path: '/wx_equipList',
      name: 'wx_equipList',
      component: () => import('@/views/wx_equipList/index'),

      hidden: true,
      meta: {
        title: '设备列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/wx_equipDetail',
      name: 'wx_equipDetail',
      component: () => import('@/views/wx_equipDetail/index'),

      hidden: true,
      meta: {
        title: '设备详情',
        keepAlive: false
      }
    },
    {
      path: '/wx_equipCheck',
      name: 'wx_equipCheck',
      component: () => import('@/views/wx_equipCheck/index'),

      hidden: true,
      meta: {
        title: '设备检查',
        keepAlive: false
      }
    },
    {
      path: '/wx_equipUpkeep',
      name: 'wx_equipUpkeep',
      component: () => import('@/views/wx_equipUpkeep/index'),

      hidden: true,
      meta: {
        title: '设备保养',
        keepAlive: false
      }
    },
    {
      path: '/wx_equipCheckHistory',
      name: 'wx_equipCheckHistory',
      component: () => import('@/views/wx_equipCheckHistory/index'),

      hidden: true,
      meta: {
        title: '检查记录',
        keepAlive: false
      }
    },
    {
      path: '/wx_caller',
      name: 'wx_caller',
      component: () => import('@/views/wx_caller/index'),

      hidden: true,
      meta: {
        title: '访客登记',
        keepAlive: false
      }
    },
    {
      path: '/wx_verify',
      name: 'wx_verify',
      component: () => import('@/views/wx_verify/index'),

      hidden: true,
      meta: {
        title: '访客通行证',
        keepAlive: false
      }
    },
    {
      path: '/wx_inviteCode',
      name: 'wx_inviteCode',
      component: () => import('@/views/wx_inviteCode/index'),

      hidden: true,
      meta: {
        title: '邀请码',
        keepAlive: false
      }
    },{
      path: '/wx_abcAccount',
      name: 'wx_abcAccount',
      component: () => import('@/views/wx_abcAccount/index'),
      hidden: true,
      meta: {
        title: '农行开户',
        keepAlive: false
      }
    },{
      path: '/wx_abcReturn',
      name: 'wx_abcReturn',
      component: () => import('@/views/wx_abcReturn/index'),
      hidden: true,
      meta: {
        title: '回调页面',
        keepAlive: false
      }
    },{
      path: '/wx_abcWorks',
      name: 'wx_abcWorks',
      component: () => import('@/views/wx_abcWorks/index'),
      hidden: true,
      meta: {
        title: '转入转出',
        keepAlive: false
      }
    },{
      path: '/wx_abcWorkFinds',
      name: 'wx_abcWorkFinds',
      component: () => import('@/views/wx_abcWorkFinds/index'),
      hidden: true,
      meta: {
        title: '转账查询',
        keepAlive: false
      }
    },{
      path: '/wx_abcOpenFinds',
      name: 'wx_abcOpenFinds',
      component: () => import('@/views/wx_abcOpenFinds/index'),
      hidden: true,
      meta: {
        title: '开户查询',
        keepAlive: false
      }
    },

    //预览和下载缴费通知单
    {
      path: '/wx_myNoticemngMg',
      name: 'wx_myNoticemngMg',
      component: () => import('@/views/wx_myNoticemngMg/index'),
      hidden: true,
      meta: {
        title: '预览和下载',
        keepAlive: false
      }
    },
    //我的申请
    {
      path: '/wx_applications',
      name: 'wx_applications',
      component: () => import('@/views/wx_applications/index'),
      hidden: true,
      meta: {
        title: '我的申请',
        keepAlive: false
      }
    },
    //我的申请列表
    {
      path: '/wx_applicationsList',
      name: 'wx_applicationsList',
      component: () => import('@/views/wx_applicationsList/index'),
      hidden: true,
      meta: {
        title: '我的申请列表',
        keepAlive: false
      }
    },
    //我的申请填写
    {
      path: '/wx_applicationsApply',
      name: 'wx_applicationsApply',
      component: () => import('@/views/wx_applicationsApply/index'),
      hidden: true,
      meta: {
        title: '我的申请填写',
        keepAlive: false
      }
    },
    {
      path: '/wx_applicationsApply/purchaseApply',
      name: 'purchaseApply',
      component: () => import('@/views/wx_applicationsApply/purchaseApply'),
      hidden: true,
      meta: {
        title: '物料申购申请填写',
        keepAlive: false
      }
    },
    //我的审批
    {
      path: '/wx_approval',
      name: 'wx_approval',
      component: () => import('@/views/wx_approval/index'),
      hidden: true,
      meta: {
        title: '我的审批',
        keepAlive: false
      }
    },
    //我的审批列表
    {
      path: '/wx_approvalList',
      name: 'wx_approvalList',
      component: () => import('@/views/wx_approvalList/index'),
      hidden: true,
      meta: {
        title: '我的审批',
        keepAlive: false
      }
    },
    // 租赁审批
    {
      path: '/wx_approvalDetail',
      name: 'wx_approvalDetail',
      component: () => import('@/views/wx_approvalDetail/index'),
      hidden: true,
      meta: {
        title: '我的审批',
        keepAlive: false
      }
    },
    // 自定义审批
    {
      path: '/wx_customDetail',
      name: 'wx_customDetail',
      component: () => import('@/views/wx_approvalDetail/customDetail'),
      hidden: true,
      meta: {
        title: '自定义审批',
        keepAlive: false
      }
    },
    // 入职审批
    {
      path: '/wx_entryApply',
      name: 'wx_entryApply',
      component: () => import('@/views/wx_approvalDetail/entryApply'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 调岗审批
    {
      path: '/wx_transferDetail',
      name: 'wx_transferDetail',
      component: () => import('@/views/wx_approvalDetail/transferDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 转正审批
    {
      path: '/wx_promotionDetail',
      name: 'wx_promotionDetail',
      component: () => import('@/views/wx_approvalDetail/promotionDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 调薪审批
    {
      path: '/wx_adjustDetail',
      name: 'wx_adjustDetail',
      component: () => import('@/views/wx_approvalDetail/adjustDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 离职审批
    {
      path: '/wx_resignDetail',
      name: 'wx_resignDetail',
      component: () => import('@/views/wx_approvalDetail/resignDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 请假
    {
      path: '/wx_recessDetail',
      name: 'wx_recessDetail',
      component: () => import('@/views/wx_approvalDetail/recessDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 合同审批
    {
      path: '/wx_contractDetail',
      name: 'wx_contractDetail',
      component: () => import('@/views/wx_approvalDetail/contractDetail'),
      hidden: true,
      meta: {
        title: '入职审批',
        keepAlive: false
      }
    },
    // 资金日报表审批
    {
      path: '/wx_dailyStatement',
      name: 'wx_dailyStatement',
      component: () => import('@/views/wx_approvalDetail/dailyStatement'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 应收减免审批
    {
      path: '/wx_receAdjust',
      name: 'wx_receAdjust',
      component: () => import('@/views/wx_approvalDetail/receAdjust'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 退款审批
    {
      path: '/wx_payBack',
      name: 'wx_payBack',
      component: () => import('@/views/wx_approvalDetail/wx_payBack'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 采购申请审批
    {
      path: '/wx_purchaseDetail',
      name: 'wx_purchaseDetail',
      component: () => import('@/views/wx_approvalDetail/purchaseDetail'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 报销申请审批
    {
      path: '/wx_claimsDetail',
      name: 'wx_claimsDetail',
      component: () => import('@/views/wx_approvalDetail/claimsDetail'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 差旅费申请审批
    {
      path: '/wx_travelClaimsDetail',
      name: 'wx_travelClaimsDetail',
      component: () => import('@/views/wx_approvalDetail/travelClaimsDetail'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 借支单申请审批
    {
      path: '/wx_lendBillDetail',
      name: 'wx_lendBillDetail',
      component: () => import('@/views/wx_approvalDetail/lendBillDetail'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 合同付款审批
    {
      path: '/wx_contractPay',
      name: 'wx_contractPay',
      component: () => import('@/views/wx_approvalDetail/contractPay'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 预算变更审批
    {
      path: '/wx_budgetChange',
      name: 'wx_budgetChange',
      component: () => import('@/views/wx_approvalDetail/budgetChange'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 月计划申报审批
    {
      path: '/wx_budgetMonth',
      name: 'wx_budgetMonth',
      component: () => import('@/views/wx_approvalDetail/budgetMonth'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    // 项目立项审批
    {
      path: '/wx_businProject',
      name: 'wx_businProject',
      component: () => import('@/views/wx_approvalDetail/businProject'),
      hidden: true,
      meta: {
        title: '应收减免审批',
        keepAlive: false
      }
    },
    //周边商家
    {
      path: '/wx_surrounding',
      name: 'wx_surrounding',
      component: () => import('@/views/wx_surrounding/index'),

      hidden: true,
      meta: {
        title: '周边商家',
        keepAlive: false
      }
    },
    //周边商家详情
    {
      path: '/wx_surroundingDetail',
      name: 'wx_surroundingDetail',
      component: () => import('@/views/wx_surroundingDetail/index'),

      hidden: true,
      meta: {
        title: '周边商家',
        keepAlive: false
      }
    },
    //家庭成员
    {
      path: '/wx_familyMembers',
      name: 'wx_familyMembers',
      component: () => import('@/views/wx_familyMembers/index'),

      hidden: true,
      meta: {
        title: '家庭成员',
        keepAlive: false
      }
    },

    //家庭成员新增
    {
      path: '/wx_familyMembersAdd',
      name: 'wx_familyMembersAdd',
      component: () => import('@/views/wx_familyMembersAdd/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    //家庭成员查看
    {
      path: '/wx_familyMembersDetail',
      name: 'wx_familyMembersDetail',
      component: () => import('@/views/wx_familyMembersDetail/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    //家庭成员编辑
    {
      path: '/wx_familyMembersEedit',
      name: 'wx_familyMembersEedit',
      component: () => import('@/views/wx_familyMembersEedit/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    // 装修申请
    {
      path: '/wx_decoration',
      name: 'wx_decoration',
      component: () => import('@/views/wx_decoration/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    // 装修申请列表(申请)
    {
      path: '/wx_decorationLs',
      name: 'wx_decorationLs',
      component: () => import('@/views/wx_decorationLs/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    // 装修巡检
    {
      path: '/wx_decorationPoll',
      name: 'wx_decorationPoll',
      component: () => import('@/views/wx_decorationPoll/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    // 装修申请列表(巡检)
    {
      path: '/wx_decorationList',
      name: 'wx_decorationList',
      component: () => import('@/views/wx_decorationList/index'),

      hidden: true,
      meta: {
        title: '家庭成员列表',
        keepAlive: false
      }
    },
    // 保洁服务
    {
      path: '/wx_clean',
      name: 'wx_clean',
      component: () => import('@/views/wx_clean/index'),

      hidden: true,
      meta: {
        title: '保洁服务',
        keepAlive: false
      }
    },
    {
      path: '/wx_clean_task',
      name: 'wx_clean_task',
      component: () => import('@/views/wx_clean_task/index'),

      hidden: true,
      meta: {
        title: '服务路线',
        keepAlive: false
      }
    },
    {
      path: '/wx_clean_task_resuilt',
      name: 'wx_clean_task_resuilt',
      component: () => import('@/views/wx_clean_task_resuilt/index'),

      hidden: true,
      meta: {
        title: '服务结果',
        keepAlive: false
      }
    },
    // 保洁检查
    {
      path: '/wx_check',
      name: 'wx_check',
      component: () => import('@/views/wx_check/index'),

      hidden: true,
      meta: {
        title: '保洁检查',
        keepAlive: false
      }
    },
    {
      path: '/wx_check_task',
      name: 'wx_check_task',
      component: () => import('@/views/wx_check_task/index'),

      hidden: true,
      meta: {
        title: '服务路线',
        keepAlive: false
      }
    },
    {
      path: '/wx_check_task_resuilt',
      name: 'wx_check_task_resuilt',
      component: () => import('@/views/wx_check_task_resuilt/index'),

      hidden: true,
      meta: {
        title: '结果检查',
        keepAlive: false
      }
    },
    {
      path: '/wx_check_task_again',
      name: 'wx_check_task_again',
      component: () => import('@/views/wx_check_task_again/index'),

      hidden: true,
      meta: {
        title: '保洁返工',
        keepAlive: false
      }
    },
    // 公益捐赠
    {
      path: '/wx_publicWelfare',
      name: 'wx_publicWelfare',
      component: () => import('@/views/wx_publicWelfare/index'),
      hidden: true,
      meta: {
        title: '公益捐赠列表',
        keepAlive: false
      }
    },

      // 公益捐赠详情
      {
        path: '/wx_publicWelfare_detail',
        name: 'wx_publicWelfare_detail',
        component: () => import('@/views/wx_publicWelfare_detail/index'),
        hidden: true,
        meta: {
          title: '公益捐赠列表',
          keepAlive: false
        }
      },

    {
      path: '/wx_suggestions',
      name: 'wx_suggestions',
      component: () => import('@/views/wx_suggestions/index'),
      hidden: true,
      meta: {
        title: '投诉建议',
        keepAlive: false
      }
    },

    {
      path: '/wx_suggestionsAdd',
      name: 'wx_suggestionsAdd',
      component: () => import('@/views/wx_suggestionsAdd/index'),
      hidden: true,
      meta: {
        title: '添加反馈',
        keepAlive: false
      }
    },

    {
      path: '/wx_suggestionsDetail',
      name: 'wx_suggestionsDetail',
      component: () => import('@/views/wx_suggestionsDetail/index'),
      hidden: true,
      meta: {
        title: '反馈详情',
        keepAlive: false
      }
    },
    {
      path: '/wx_fundsSum',
      name: 'wx_fundsSum',
      component: () => import('@/views/wx_fundsSum/index'),
      hidden: true,
      meta: {
        title: '资金汇总',
        keepAlive: false
      }
    },
    {
      path: '/wx_chargeRecords',
      name: 'wx_chargeRecords',
      component: () => import('@/views/wx_chargeRecords/index'),
      hidden: true,
      meta: {
        title: '资金汇总',
        keepAlive: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js